const $                       = require('jquery');
const { memoize, partition }  = require('underscore');
const menu                    = require('./sidenav');
const evtbus                  = require('../evtbus');
const supplementTpl           = require('../template/supplement_tpl');
const videoTpl                = require('../template/video_tpl');

const fa = {
  fileWord: require('@fortawesome/pro-light-svg-icons/faFileWord').definition,
};

class Supplements {
  constructor({ container, metadata }) {
    if (!metadata.supplements?.length) return;

    this._elem = $(`<div class="content"></div>`);
    this._elem.appendTo(container);

    const [videos, supplements] = partition(metadata.supplements, s => /^video$/i.test(s.type))

    const renderMemo = memoize(() => {
      return this._render({ supplements, videos });
    });

    menu.add({
      id: 'supplements',
      icon: fa.fileWord,
      title: 'Supplements',
      badge: supplements.length + videos.length,
      render: renderMemo
    });
  }

  _render({ supplements, videos }) {
    this._elem.empty();
    this._elem.append(this._suplementList({ supplements }));
    this._elem.append(this._videoList({ videos }));
    return this._elem;
  }

  _suplementList({ supplements }) {
    return supplementTpl.compile({ supplements });
  }

  _videoList({ videos }) {
    return videoTpl.compile({ videos });
  }
}

module.exports = Supplements;

